"use client"
import React, { useState,useEffect } from 'react'
import Link from 'next/link'

import HomeBanner from '../components/HomeBanner'
import HomeMap from '../components/HomeMap'
import HomeUltimateSolution from '../components/HomeUltimateSolution'
import { BannerProvider } from '../components/BannerContext'
import WhoweareContent from '../components/WhoweareContent'
import AshlokClient from '../components/AshlokClient'

import Head from 'next/head';




export default function Login() {
 

  // useEffect(() => {
  //   document.title = "Explore Innovative Lighting Solutions for Your Home – Ashlok";
  //   document
  //     .querySelector("meta[name='description']")
  //     .setAttribute("content", "Discover Ashlok’s range of modern, energy-efficient lighting solutions to elevate your home decor with style and function. Shop now for a brighter future!");
  // }, []);
    return (
      <>
      
        <BannerProvider>
        <HomeBanner/>
        </BannerProvider>
           <HomeMap/>
            <HomeUltimateSolution page="home"/>
        <WhoweareContent/>
       <AshlokClient/>
       
        </>
    )
}

